<template>
  <WbdWorkerList />
</template>
<script>


import WbdWorkerList from '@/views/offer/worker-list'

export default {
  name: 'WbdWorkerDashboard',
  components: {
    WbdWorkerList
  },
  data: () => ({

  }),
  computed: {

  },
  watch: {
  },
  async  created () {
  },
  methods: {}

}
</script>

